import { withKeys as _withKeys, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = { class: "input-icon form-floating" }
const _hoisted_3 = ["id", "readonly"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_validation_label = _resolveComponent("validation-label")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        ref: "textInput",
        type: "text",
        placeholder: "value",
        id: $props.elementId,
        onKeypress: _cache[0] || (_cache[0] = ($event: any) => ($options.keyPress($event))),
        onMousedown: _cache[1] || (_cache[1] = ($event: any) => ($options.onMousedown())),
        onMouseup: _cache[2] || (_cache[2] = ($event: any) => ($options.onMouseup($event))),
        onFocus: _cache[3] || (_cache[3] = ($event: any) => ($options.gotfocus($event))),
        onBlur: _cache[4] || (_cache[4] = ($event: any) => ($options.lostfocus())),
        class: "form-control",
        onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => ($options.onEnterPressed()), ["enter"])),
        readonly: $options.isReadonly
      }, null, 40, _hoisted_3),
      _cache[6] || (_cache[6] = _createElementVNode("i", null, "£", -1)),
      _createVNode(_component_validation_label, {
        ref: "label",
        elementId: $props.elementId,
        text: $props.description,
        abbreviatedText: $props.abbreviatedDescription
      }, null, 8, ["elementId", "text", "abbreviatedText"])
    ])
  ]))
}